<template>
    <div>
        <Header />
        <div class="desktop">
            <BlackHeaderCenter :headerText="headerText" :subText="subText" :fadedText="fadedText" />
        </div>
        <div class="mobile">
            <BlackHeaderMobile :headerText="headerText" :subText="subText" :fadedText="fadedText"
                :isTextinput="false" />
        </div>
        <BodyLinks />
        <b-container class=" mt-4">
            <Activation />
            <b-row class="desktop">
                <b-col cols="3">
                    <RecipeSidebar class="mt-5" recipes='active' />
                </b-col>
                <b-col cols="9">
                    <b-row class="head-box mb-5">
                        <b-col cols="4" class="">
                            <b-input-group class="">
                                <b-input-group-prepend is-text>
                                    <b-icon font-scale="0.99" icon="bucket"></b-icon>
                                </b-input-group-prepend>
                                <b-form-input type="text" v-model="name" placeholder="Recipe Name "></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col cols="4" class="">
                            <b-input-group class="">
                                <b-input-group-prepend is-text>
                                    <b-icon font-scale="0.99" icon="tag"></b-icon>
                                </b-input-group-prepend>
                                <b-form-input type="text" v-model="origin" placeholder="Recipes or origin ">
                                </b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col cols="4" class="btn-box">
                            <button @click="searchFood" class="btn btn-warning btn-culture">
                                <b-icon font-scale="0.99" icon="search"></b-icon>Search
                            </button>
                        </b-col>
                    </b-row>
                    <div v-if="loading">
                        <content-loader :speed="2" :height="400" :width="700">
                            <rect x="4" y="8" rx="3" ry="3" width="7" height="288" />
                            <rect x="6" y="289" rx="3" ry="3" width="669" height="8" />
                            <rect x="670" y="9" rx="3" ry="3" width="6" height="285" />
                            <rect x="55" y="42" rx="16" ry="16" width="274" height="216" />
                            <rect x="412" y="113" rx="3" ry="3" width="102" height="7" />
                            <rect x="402" y="91" rx="3" ry="3" width="178" height="6" />
                            <rect x="405" y="139" rx="3" ry="3" width="178" height="6" />
                            <rect x="416" y="162" rx="3" ry="3" width="102" height="7" />
                            <rect x="405" y="189" rx="3" ry="3" width="178" height="6" />
                            <rect x="5" y="8" rx="3" ry="3" width="669" height="7" />
                            <rect x="406" y="223" rx="14" ry="14" width="72" height="32" />
                            <rect x="505" y="224" rx="14" ry="14" width="72" height="32" />
                            <rect x="376" y="41" rx="3" ry="3" width="231" height="29" />
                        </content-loader>
                    </div>
                    <div v-if="recipes.length > 0">
                        <p class="mb-4 d-flex justify-content-between">
                            <span>
                                Per page:
                                <select class="" v-model="no_per_page" @change="getRecepies(page)">
                                    <option value="5" selected>5</option>
                                    <option value="15">15</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                </select> items
                            </span>
                            <span>{{page}} of {{rows}} recipes</span>
                        </p>
                        <b-row class="mb-3 eventcard" v-for="(food, index) in recipes" :key="index">
                            <b-col class="firstcol col-md-6"
                                v-bind:style='{ backgroundImage: "url(" + food.images + ")", }'>

                            </b-col>
                            <b-col class="firstborder-right">
                                <div class="justify-content-end d-flex font10 mt-3">
                                    Cuisine origin: <span class="culture-primary ml-1"> {{food.origin}}</span>
                                </div>
                                <div class="text-center text-capitalize font-weight-600 font16 mt-3">
                                    {{food.name}}
                                </div>
                                <div class="font12">
                                    <b-form-rating readonly show-value inline size="sm" v-model="food.average_ratings">
                                    </b-form-rating>
                                </div>
                                <p class="font10">
                                      <span :inner-html.prop="food.storyline | truncate(100)"></span>  
                                    
                                </p>
                                <p class="culture-primary font12">
                                    <span>Download full recipe for:</span> <span class="font-weight-600">{{food.fee_type
                                        === 'paid' ?
                                        food.amount: 'Free'}} {{food.fee_type === 'paid' ? food.currency: ''}}</span>
                                </p>
                                <p class="font12">
                                    <span>Cook Time</span>: {{food.cook_time}}
                                </p>
                                <p class="font12">
                                    <span>Prep Time</span>: {{food.prep_time}}
                                </p>
                                <div class="font12 mt-2">
                                    <router-link class="font-weight-600 text-success mr-3"
                                        :to="{ name: 'recipe-details', params: {id: food.food_id} }">
                                        {{food.hire_status === 1 ? 'Chef is available for hire':''}}
                                    </router-link>
                                    
                                </div>
                                <div class="button-list">
                                    <router-link
                                        :to="{ name: 'public-profile', params: {cook:food.cook, isPublicProfile: true, id: food.cook.user_id }}"
                                        class="btn btn-warning btn-below font10">
                                        <b-icon font-scale="0.99" icon="person"></b-icon> Chef
                                    </router-link>
                                    <button @click="openIngredients(food)" v-b-modal="'ingredients'"
                                        class="btn btn-warning btn-below font10">
                                        <b-icon font-scale="0.99" icon="basket"></b-icon> Ingredients
                                    </button>
                                    <button @click="openrateRecipe(food)" v-b-modal="'rate-food'"
                                        class="btn btn-warning btn-below font10">
                                        <b-icon font-scale="0.99" icon="heart"></b-icon> Review
                                    </button>
                                    <router-link class="btn btn-warning btn-below font10"
                                        :to="{ name: 'recipe-details', params: {id: food.food_id} }">
                                        <b-icon font-scale="0.99" icon="list"></b-icon> Details
                                    </router-link>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                    <div v-if="recipes.length == 0 && !loading">
                        No recipe created yet, be the first to <router-link class="culture-primary"
                            to="/recipes/create"> create </router-link> one
                    </div>
                    <div v-if="recipes.length >0">
                        <b-pagination v-model="page" :total-rows="rows" @change="getRecepies" :per-page="no_per_page">
                        </b-pagination>
                    </div>
                </b-col>
            </b-row>
            <div class="mobile">
                <b-row>
                    <b-col cols="3">
                        <RecipeSidebar menuId="slidmenu" @handleOpen="openMenu" @handleHide="hideSidemenu" class="mt-5"
                            recipes='active' />
                    </b-col>
                    <b-col cols="9">
                        <b-row class="head-box mb-5">
                            <b-col cols="12" class="">
                                <b-input-group class="">
                                    <b-input-group-prepend is-text>
                                        <b-icon font-scale="0.99" icon="bucket"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="text" v-model="name" placeholder="Recipe Name "></b-form-input>
                                </b-input-group>
                            </b-col>
                            <b-col cols="12" class="">
                                <b-input-group class="">
                                    <b-input-group-prepend is-text>
                                        <b-icon font-scale="0.99" icon="tag"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="text" v-model="origin" placeholder="Recipe/origin ">
                                    </b-form-input>
                                </b-input-group>
                            </b-col>
                            <b-col cols="12" class="btn-box ">
                                <button @click="searchFood" class="d-inline-flex btn btn-warning btn-culture">
                                    Search
                                </button>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <p class="mb-4">{{page}} of {{rows}} recipes</p>
                <div class="mb-3 p-3 eventcard" v-for="(food, index) in recipes" :key="index">
                    <div class="row ml-0">
                        <img :src="food.images" alt="" style="width:40%;height:100px">
                        <div class="ml-3">
                            <div class="font10 mt-1">
                                Origin: <span class="culture-primary">{{food.origin}}</span>
                            </div>
                            <div class="text-capitalize font-weight-600 font14 mt-1">
                                {{food.name |truncate(15)}}
                            </div>
                            <div class="font12">
                                <b-form-rating readonly show-value inline size="sm" v-model="food.average_ratings">
                                </b-form-rating>
                            </div>
                        </div>

                    </div>

                    <p class="font10 mt-3">
                        {{food.storyline | truncate(80)}}
                    </p>
                    <p class="culture-primary font12 ">
                        <span>Download full recipe for::</span> {{food.fee_type === 'paid' ? food.amount: 'Free'}}
                        {{food.fee_type ===
                        'paid' ? food.currency: ''}}
                    </p>
                    <p class="font12">
                        <span>Cook Time</span>: {{food.cook_time}}
                    </p>
                    <div class="font12">
                        <span class="font-weight-600 text-success mr-3">
                            {{food.hire_status === 1 ? 'Chef is available for hire':''}}
                        </span>
                    </div>

                    <div class="flex mt-2">
                        <router-link :to="{ name: 'public-profile', params: {id: food.cook.user_id }}"
                            class="btn btn-warning btn-below font10">
                            <b-icon font-scale="0.99" icon="person"></b-icon> Chef
                        </router-link>
                        <button @click="openIngredients(food)" v-b-modal="'ingredients'"
                            class="btn btn-warning btn-below font10">
                            <b-icon font-scale="0.99" icon="basket"></b-icon> Ingredients
                        </button>
                        <button @click="openrateRecipe(food)" v-b-modal="'rate-food'"
                            class="btn btn-warning btn-below font10">
                            <b-icon font-scale="0.99" icon="heart"></b-icon> Review
                        </button>
                        <router-link class="btn btn-warning btn-below font10"
                            :to="{ name: 'recipe-details', params: {id: food.food_id} }">
                            <b-icon font-scale="0.99" icon="list"></b-icon> Details
                        </router-link>

                    </div>

                </div>
                <div v-if="recipes.length == 0 && !loading">
                    No recipe created yet, be the first to <router-link class="culture-primary" to="/recipes/create">
                        create </router-link> one
                </div>
                <div v-if="recipes.length >0">
                    <b-pagination v-model="page" :total-rows="rows" @change="getRecepies" :per-page="no_per_page">
                    </b-pagination>
                </div>
            </div>
            <b-modal id="ingredients" centered title="Ingredients" hide-footer>
                <ul>
                    <li v-for="(ing, index) in ingredients" :key="index">
                        <b-icon shift-v="-3" font-scale="1" icon="check-all"></b-icon> {{ing.item}}
                    </li>
                </ul>
            </b-modal>
            <b-modal id="location" centered title="Find it here" hide-footer>
                <b-icon font-scale="0.99" icon="geo"></b-icon> {{food.link}}
            </b-modal>
            <b-modal id="rate-food" centered hide-header title="Rate Recipe" hide-footer>
                <b-tabs card>
                    <b-tab title="Reviews" active>
                        <b-card-text>
                            <div class="row" v-for="(rate, index) in reviews " :key="index">
                                <b-col cols="2">
                                    <img class="rating-profile" :src="rate.rater.photo_thumb" alt="">
                                </b-col>
                                <b-col cols="10">
                                    <div class="font12">{{rate.rater.first_name}}</div>
                                    <b-form-rating readonly show-value inline size="sm" v-model="rate.rating">
                                    </b-form-rating>
                                    <p class="font10">
                                        {{rate.comment}} </p>
                                </b-col>
                            </div>

                        </b-card-text>
                    </b-tab>
                    <b-tab title="Rate Recipe">
                        <b-card-text>
                            <div class="text-center">
                                <p class="rating-title">{{food.average_ratings}}</p>
                                <p>Total Avg. Ratings</p>
                                <b-form-rating class="star-icon mb-3" show-value size="lg" v-model="rating">
                                </b-form-rating>
                                <b-form-group class="mb-3" label-for="comment">
                                    <textarea style="height:auto !important" required rows="5" v-model="comment"
                                        placeholder="Comment" class="shadow custom-control form-control"></textarea>
                                </b-form-group>
                                <button @click="rateRecipe(food)" class="btn btn-warning btn-below">
                                    <b-icon font-scale="0.99" icon="heart"></b-icon> Rate Now
                                </button>
                            </div>
                        </b-card-text>
                    </b-tab>
                </b-tabs>

            </b-modal>
        </b-container>
        <Footer />
    </div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import BodyLinks from "@/components/BodyLinks.vue";
import Footer from "@/components/Footer.vue";
import BlackHeaderCenter from "@/components/BlackHeaderCenter.vue";
import BlackHeaderMobile from "@/components/BlackHeaderMobile.vue";
import RecipeSidebar from "@/components/RecipeSidebar.vue";
import Activation from "@/components/Activation.vue";
import vClickOutside from 'v-click-outside'

import {
    ContentLoader
} from "vue-content-loader";

import axios from "axios";
import {
    getBaseUrl
} from "../../../utils/common";
const base_url = getBaseUrl();
export default {
    name: 'food-listings',
    directives: {
        clickOutside: vClickOutside.directive
    },
    components: {
        Header,
        BodyLinks,
        BlackHeaderCenter,
        BlackHeaderMobile,
        Activation,
        RecipeSidebar,
        ContentLoader,
        Footer,

    },
    data: function () {
        return {
            headerText: "recipes",
            subText: "See all exquisite recipes around the world",
            fadedText: "recipes",
            food: '',
            calories: '',
            name: '',
            rating: 0,
            ingredients: [],
            recipes: [],
            no_per_page: 5,
            page: 1,
            pagination: {},
            loading: true,
            comment: '',
            reviews: [],
            url: window.location.href,
            showDropdown: false,
            foodName: '',
            origin: ''
        }
    },
    mounted() {
        this.getRecepies();
    },
    computed: {
        rows() {
            return this.pagination.total
        },
        isLoggedIn: function () {
            return this.$store.getters.isLoggedIn;
        },
        currentUser: function () {
            return this.$store.getters.currentUser;
        },
    },
    metaInfo() {
        return {
            title: `Culture Square | ${this.headerText}`,
            meta: [{
                    name: 'description',
                    content: this.subText
                },
                {
                    property: "og:title",
                    content: `Culture Square | ${this.headerText}`
                },
                {
                    property: "keywords",
                    content: 'Traditional Foods, Traditional Cuisines, Traditional Recipes, Authentic food, Authentic Recipes, Authentic spices, Authentic Cuisines'
                },
                {
                    property: 'og:site_name',
                    content: 'Culture Square'
                },
                {
                    property: 'og:type',
                    content: 'website'
                },
                {
                    name: 'robots',
                    content: 'index,follow'
                }
            ]
        }

    },
    methods: {
        handleDropdown(food) {
            this.foodName = food.name
            this.showDropdown = !this.showDropdown
        },
        hideDropdown() {
            this.showDropdown = false;
        },
        openMenu() {
            this.$root.$refs.A.openMenu('slidmenu')
        },
        hideSidemenu() {
            this.$root.$refs.A.hideSidemenu('slidmenu')
        },
        gotoRecipe() {
            if (!this.isLoggedIn) {
                this.$router.push({
                    name: "sign-in",
                    query: {
                        redirect: "/listings/food/create",
                    },
                });
            } else {
                this.$router.push({
                    name: "create-foodlisting",
                });
            }
        },
        async getRecepies(page = 1) {
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/foodlistings`,
                    params: {
                        page: page,
                        no_per_page: this.no_per_page,
                        name: this.name,
                        origin: this.origin
                    },
                    method: "GET",
                })
                this.loading = false;
                this.recipes = resp.data.data;
                this.pagination = resp.data.meta;
            } catch (error) {
                this.loading = false
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        },
        async getReviews(recipe_id) {
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/flratings`,
                    params: {
                        recipe_id: recipe_id,
                    },
                    method: "GET",
                })
                this.loading = false
                this.reviews = resp.data.data
            } catch (error) {
                this.loading = false
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        },
        searchFood() {
            if (this.name === "" && this.origin === "") {
                this.$root.$refs.A.makeToast('danger', 'Enter search keywords')

            } else {
                this.getRecepies();
            }

        },
        async deleteFood(food_id) {
            if (confirm("Do you really want to delete this recipe?")) {
                try {
                    await axios({
                        url: `${base_url}/api/v2/foodlistings/${food_id}`,
                        method: "DELETE",
                    })
                    this.getRecepies();
                } catch (error) {
                    this.$root.$refs.A.makeToast('danger', error.response.data.message)
                }
            }

        },
        openIngredients(food) {
            this.food = food;
            this.ingredients = food.ingredients
        },
        openrateRecipe(food) {
            this.food = food
            this.getReviews(food.food_id)
        },
        openLocation(food) {
            this.food = food
        },
        async rateRecipe(food) {
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/flratings`,
                    data: {
                        food_listing_id: food.food_id,
                        rating: this.rating,
                        comment: this.comment
                    },
                    method: "POST",
                })
                this.$bvModal.hide('rate-food')
                this.getRecepies();
                this.$root.$refs.A.makeToast('success', resp.data.message)

            } catch (error) {
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }

        }
    }

}
</script>

<style lang="scss" scoped>
.eventcard {
    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.12);
    border-radius: 16px;
    border: none !important;
    background: #FCFCFC;
    height: 340px;

    @media screen and (min-device-width: 360px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        height: 360px;
    }
}

.eventcard .firstcol {
    padding-left: 0 !important;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 16px 0 0 16px;
    max-height: 340px
}

.button-list {
    display: flex;
    justify-content: space-between;
    position: absolute;
    bottom: 13px;
    padding-right: 45px;
    width: 100%;
}

.btn-culture {
    padding: 10px 60px !important;
    line-height: 1.9 !important;

    @media screen and (max-device-width: 320px) and (-webkit-min-device-pixel-ratio: 1) {
        line-height: 1.6 !important;
        padding: 10px 45px !important;
    }

    @media screen and (min-device-width: 360px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        line-height: 1.5 !important;
        padding: 10px 60px !important;
    }

    @media screen and (min-device-width: 760px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
        padding: 10px 30px !important;
        line-height: 3.7 !important;
    }
}

.b-icon.bi {
    margin-bottom: 2px !important
}

.bi-search {
    margin-right: 1rem;
}

.btn-box {
    margin: 14px 0
}

.list-group {
    padding: 16px 16px 16px 16px;
    background: #FFFFFF;
    box-shadow: 2px 6px 19px rgba(0, 0, 0, 0.08);
    border-radius: 4px;
}

.list-group-item {
    padding: 0.7rem 1rem !important;
    text-align: left;
    border: none !important;
    margin: 10px 0 !important;
}

.list-group-item.active {
    background: rgba(86, 92, 99, 0.05) !important;
    color: rgba(86, 92, 99, 1) !important;
    text-align: center !important
}

.head-box {
    margin: 35px auto auto;
    box-shadow: 0px 4px 20px rgb(0 0 0 / 10%);
    border-radius: 5px;
    padding: 10px;
    background-color: #F6F7F7;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        margin: 0;
    }
}

.eventcard:hover {
    border: 1px solid #F7B131 !important;
}

.inner-header-box {
    padding: 20px;
    border-radius: 4px;
    cursor: pointer;
}

.inner-header-box:hover {
    background: #000;
    color: #fff;
    border-radius: 4px;
    transition: ease-in 0.3s;

}

.inner-header-box:hover .b-icon.bi {
    color: rgba(247, 177, 49, 1)
}

.flex {
    display: flex;
    justify-content: space-between;

    @media screen and (max-device-width: 320px) and (-webkit-min-device-pixel-ratio: 1) {
        position: relative;
        bottom: -30px
    }

    @media screen and (min-device-width: 360px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        position: relative;
        bottom: -45px
    }
}

.btn-below {
    padding: 7px 11px !important
}

.form-control-sm {
    padding: 0.25rem 0 !important;
}

.form-control {
    border-radius: 0 8px 8px 0 !important;
    height: calc(2em + 0.75rem + 8px) !important;

}

.b-rating {
    height: auto !important
}

.culture-primary span {
    color: #565C63 !important
}

.slide-menu {
    position: absolute;
    z-index: 99;
    background: #fff;
    margin-left: -347%;
    width: 328%;
    top: -2px;
    padding-left: 16px;
    transition: all 0.5s ease-in-out;
}

span.del {
    cursor: pointer;
}

.rating-title {
    font-size: 32px;
    font-weight: bold
}

.rating-profile {
    border-radius: 50%;
    height: 50px;
    width: 50px
}

a {
    color: #565C63
}

.dropdown {
    display: block;
    position: absolute;
    width: 50px;
    background-color: #fff;
    -webkit-transition: all 0.3s ease-out 0s;
    -o-transition: all 0.3s ease-out 0s;
    transition: all 0.3s ease-out 0s;
    z-index: 999;
    -webkit-box-shadow: 0 2px 8px 0 rgb(0 29 35 / 5%);
    box-shadow: 0 2px 8px 0 rgb(0 29 35 / 5%);
    bottom: calc(100% + -12px);
    padding: 0 !important;
    border-radius: 5px;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        width: 44px;
        bottom: 17px;
    }
}

.dropdown li {
    line-height: 1;
    margin: 0;
    margin: 10px;
    border-radius: 4px;
}
</style>
